import { MenuItem } from '@mui/material';
import CustomEditor from '../utils/CustomEditor';
import './PostTalentPage.scss'
import CustomSelect from '../utils/customSelect';
import CustomTextField from '../utils/CustomTextField';
import Form from '../utils/Form';
import CustomUnitInput from '../utils/CustomUnitInput';


function PostProjectTemplate({setter}) {

    const talentCategories = [
        'Proof Reading',
        'Book Editing',
        'Article Editing',
        'Rewriting & Revisions',
        'Technical Editing',
        'Article Editing',
        'Book Editing',
        'Book Editing',
        'Book Editing',
        'Book Editing',
    ];

    const currencies = [
        {
            symbol: '₹',
            name: 'Rupees'
        },
        {
            symbol: '$',
            name: 'Dollars'
        },
        {
            symbol: '€',
            name: 'Euro'
        },
        {
            symbol: '¥',
            name: 'Yen'
        },
        {
            symbol: '£',
            name: 'Pounds'
        }
    ];

    const Terms = [
        'Month',
        'Year'
    ];

    const durationTypes = [
        'Days',
        'Weeks',
        'Months'
    ];

    const formData = {
        projectType: '',
        categories: [],
        title: '',
        description: '',
        experience: {
            unit: '',
            amount: ''
        },
        price: {
            unit: '',
            amount: '',
        },
        duration: {
            unit: '',
            amount: ''
        },
        email: '',
        mobile: ''
    }

    return (
        <div className="post-talent-template-wrp">
            {/* <div className='talent-title'>Proof Reading Jobs</div> */}
            <div className='desc-wrp'>
                <div className='desc-title'>Post Your Project</div>
                <div className='description'>Simply post your project - What work you wanted as parttime/fulltime at what price you want to hire.</div>
            </div>
            <div className='talent-info-wrp'>
                <Form formData={formData} onSubmit={(e,d) => { 
                    console.log(d);
                }} render={(data, onchange) =>
                    <>
                        <div className='categories-input-wrp'>
                            <label>Project Type</label>
                            <CustomSelect parent={data} prop='projectType' required className='categories' name='projectType'
                                options={talentCategories} value={data?.projectType} onChange={ (e) => { setter(e.target.value); onchange(e);}}
                            />
                        </div>
                        <div className='categories-input-wrp'>
                            <label>{data?.projectType} Categories</label>
                            <CustomSelect parent={data} prop='categories' required outerSelection={true} className='categories' name='categories'
                                options={talentCategories} multiple={true} value={data?.categories} onChange={onchange}
                                renderValue={(selected) => 'Select Sub Categories'}
                            />
                        </div>
                        <div className='title-input-container'>
                            <CustomTextField name='title' label='Title' required className='title-input' placeholder='Title' value={data?.title} inputProps={{ maxLength: 100 }} onChange={onchange} />
                        </div>
                        <div className='title-input-container'>
                            <label>Description</label>
                            <div className='desc'>Simply describe your project with some introduction, Experience, your past Projects and Clients, etc</div>
                            <CustomEditor onChange={onchange} parent={data} prop='description' value={data?.description}></CustomEditor>
                        </div>
                        <div className='inputs-wrp'>
                            <CustomUnitInput
                                className='experience'
                                label='Experience' placeholder='Experience'
                                parent={data}
                                prop='experience'
                                unit={{
                                    value: data?.experience?.unit || Terms[1],
                                    options: Terms,
                                    prop: 'name'
                                }}
                                amount={data?.experience?.amount}
                                onChange={onchange}
                            />
                            <CustomUnitInput
                                label='Price' placeholder='Price'
                                className='price'
                                parent={data}
                                prop='price'
                                unit={{
                                    value: data?.price?.unit || currencies[0],
                                    options: currencies,
                                    prop: 'symbol',
                                    renderValue: (selected) => selected.symbol,
                                    renderOptions: ((c, i) => <MenuItem key={i} value={c}>{c.symbol} - {c.name}</MenuItem>)
                                }}
                                amount={data?.price?.amount}
                                onChange={onchange}
                            />
                        </div>
                        <div className='inputs-wrp'>
                            <CustomUnitInput
                                className='duration-input'
                                label='Duration' placeholder='Duration'
                                parent={data}
                                prop='duration'
                                unit={{
                                    value: data?.duration?.unit || durationTypes[0],
                                    options: durationTypes,
                                    prop: 'name'
                                }}
                                amount={data?.duration?.amount}
                                onChange={onchange}
                            />
                        </div>
                        <div className='inputs-wrp'>
                            <CustomTextField name='email'  required type='email' label='Email Id' className='email-input' placeholder='Email Id' value={data?.email} inputProps={{ maxLength: 100 }} onChange={onchange} />
                            <CustomTextField name='mobile'  required type='number' label='Mobile Number' className='mobile-input' placeholder='Mobile Number' value={data?.mobile} onChange={onchange} />
                        </div>
                        <button className='submit-form' type='submit'>Post Project</button>
                    </>
                }></Form>
            </div>
        </div>
    );
};
export default PostProjectTemplate;